import { limitAmplitude } from '@mote/assets/logo/AudioPlaybackUtils'
import { Avatar } from '@mote/ui'
import React from 'react'
import styled from 'styled-components'
import { useMotePlayer } from '../../shared/contexts/motePlayer.context'
import { moteCardFluidDimensionsAdjuster } from './fluidSizing'
import { MoteCardAudioVisualization } from './MoteCardRichAudioVisualization'

export function MoteCardRichAvatarWithAnimation({
  transcript,
  createdByName,
  createdByAvatar
}) {
  const { paused: isPaused, theme, playerDimensions } = useMotePlayer()

  const rootSize = React.useMemo(
    () =>
      moteCardFluidDimensionsAdjuster(
        transcript || (transcript && isPaused) ? 207 : 354,
        transcript || (transcript && isPaused) ? 92 : 153,
        playerDimensions?.width
      ),
    [transcript, isPaused, playerDimensions]
  )

  const avatarSize = React.useMemo(
    () =>
      transcript || (transcript && isPaused)
        ? moteCardFluidDimensionsAdjuster(138, 62, playerDimensions?.width)
        : moteCardFluidDimensionsAdjuster(230, 102, playerDimensions?.width),
    [transcript, isPaused, playerDimensions]
  )

  return (
    <Root tabIndex={-1} size={rootSize}>
      <Container size={avatarSize}>
        <MoteCardAudioVisualization />
        <StyledAvatar
          tabIndex={-1}
          size={avatarSize}
          text={createdByName}
          url={createdByAvatar}
        />
      </Container>
    </Root>
  )
}

const Root = styled.div`
  position: relative;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  outline: none;
  pointer-events: none;
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
`

const Container = styled.div`
  position: relative;
  border-radius: 50%;
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
`

const StyledAvatar = styled(Avatar)`
  width: 100%;
  height: 100%;
`
